import { SM } from '../assets/data/enum/storeModel.enum';
import { productionBase } from './base/production.base';

export const environment = {
  ...productionBase,
  themeConfig: {
    ...productionBase.themeConfig,
    brand: 'krukowiak',
    textName: 'Krukowiak Farm Management',
    termsAndCondition: 'https://legal.xfarm.ag/#/terms-and-conditions?l=it&v=latest&b=krukowiak',
    privacyPolicy: 'https://legal.xfarm.ag/#/privacy-policy?l=it&v=latest&b=krukowiak',
    legalModeBySaas: true,
    forceHideFunctionalityList: [
      SM.SM_ANALYTICS_SUSTAINABILITY,
      SM.SM_ANALYTICS_IMPACT,
      SM.SM_ANALYTICS_REGENERATIVE,
      SM.SM_ANALYTICS_OVERVIEW,
      SM.SM_ANALYTICS_CHAIN_MANAGEMENT,
      SM.SM_CONTRACT_MANAGEMENT,
      SM.SM_CONTRACT_AUDIT,
      SM.SM_GUIDE,
      SM.SM_EDUCATION_EDITOR,
      SM.SM_CROP_MAP,
      SM.SM_FARM_DOSSIER,
    ],
    showYaraNPK: false,
    alertPushSelectionEnable: false,
    newsSidebarTabActivation: false,
    advEnable: false,
    versionPublicPage: 'v1',
    welcomeUserCheck: false,
    store: false,
  },
  apiBaseUrl: 'https://api-krukowiak-farm-management.xfarm.ag/',
  SSOfrontAppCallback: 'https://krukowiak-farm-management.xfarm.ag/#/oauthCheck?token=',
  launchDarklyKey: '679125d77108380b6f836707',
  assetsUrl: 'https://cdn.xfarm.ag/webapp/krukowiak/',
  palette: {
    '--p-xFarm-xColor-50': '#ffd8d1',
    '--p-xFarm-xColor-100': '#ffb1a5',
    '--p-xFarm-xColor-200': '#ff897b',
    '--p-xFarm-xColor-300': '#f85c52',
    '--p-xFarm-xColor-400': '#EB182C',
    '--p-xFarm-xColor-500': '#d11c28',
    '--p-xFarm-xColor-600': '#b81e25',
    '--p-xFarm-xColor-700': '#a01e21',
    '--p-xFarm-xColor-800': '#881e1e',
    '--p-xFarm-xColor-900': '#711c1a',
    '--p-xFarm-xColor-950': '#5b1a17',
  },
  primary: '#eb182c',
  primaryOpacity: '#eb182c',
  primaryOpacity15: '#FCE0E4',
  secondary: '#c12323',
  btnSuccess: '#eb182c',
  navBarColor: '#eb182c',
  colorSidebarHeader: '#c12323',
  spinnerSplashScreen: '#eb182c',
  backgroundSplashScreen: '#FFFFFF',
  textLoginVersion: '#FFFFFF',
};
